import LoggedOutTemplate, { Box } from "../templates/LoggedOutTemplate.jsx";
import { color, styled } from "../util/style.js";

import { Button } from "../components/typography.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import { useUserSession } from "../services/auth.js";

export default function ShopMaintenance() {
  const [session] = useUserSession();

  const Template = session ? LoggedInTemplate : LoggedOutTemplate;
  const Container = session ? LoggedInContainer : Box;

  return (
    <Template title="Erreur">
      <Container>
        <StatusCode>⚠️</StatusCode>
        <Title>Boutique en préparation&hellip;</Title>
        <Text>
          Vos boutiques sont en maintenance et reviendront dans les jours
          prochains, merci de votre patience !
        </Text>
        <Button to="/">Retour à l'accueil</Button>
      </Container>
    </Template>
  );
}

const LoggedInContainer = styled.div`
  margin: 0 auto;
  max-width: 344px;
  padding: 56px 12px;
  text-align: center;
`;

const StatusCode = styled.div`
  font-size: 72px;
  line-height: 72px;
  font-weight: bold;
  color: ${color("primary")};
  margin-bottom: 24px;
`;

const Title = styled.h2`
  margin-bottom: 24px;
`;

const Text = styled.p`
  margin-bottom: 40px;
`;
